import React from 'react';
import { Box, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { ACCENT_COLOR } from '../config/uiTheme';

/**
 * LessonCard - carte d'une lecon Guitar Pro dans la rangee Lessons de Jam.
 * Verrouillage identique aux backings : une carte verrouillee ouvre la feuille
 * d'achat du pack (onUnlock) au lieu d'entrer dans la lecon.
 */
const LessonCard = ({ lesson, artist, unlocked = true, onEnterLesson, onUnlock }) => {
  const genre = (lesson.tags || [])[0];

  const handleClick = () => {
    if (!unlocked) {
      if (onUnlock) onUnlock();
      return;
    }
    if (onEnterLesson) onEnterLesson(lesson, artist);
  };

  return (
    <Box
      component="button"
      type="button"
      data-jam-focus={`lesson-${lesson.id}`}
      onClick={handleClick}
      sx={{
        border: 0,
        padding: 0,
        textAlign: 'left',
        font: 'inherit',
        minWidth: 200,
        maxWidth: 200,
        '@container jam (min-width: 640px)': { minWidth: 240, maxWidth: 240 },
        flexShrink: 0,
        cursor: 'pointer',
        backgroundColor: 'rgba(30, 30, 40, 0.6)',
        borderRadius: '12px',
        overflow: 'hidden',
        transition: 'all 0.15s ease',
        '&:hover': { backgroundColor: 'rgba(40, 40, 55, 0.8)' }
      }}
    >
      <Box sx={{
        position: 'relative',
        width: '100%',
        paddingTop: '56.25%',
        background: `linear-gradient(135deg, ${ACCENT_COLOR} 0%, ${ACCENT_COLOR}99 100%)`,
        ...(lesson.thumbnailUrl && {
          backgroundImage: `url(${lesson.thumbnailUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        })
      }}>
        {genre && (
          <Box sx={{
            position: 'absolute',
            top: 6,
            left: 6,
            backgroundColor: 'rgba(0,0,0,0.6)',
            px: 0.75,
            py: 0.15,
            borderRadius: '6px'
          }}>
            <Typography sx={{
              fontSize: '0.65rem',
              fontWeight: 700,
              color: 'white',
              textTransform: 'uppercase',
              letterSpacing: '0.04em'
            }}>
              {genre}
            </Typography>
          </Box>
        )}
        {!unlocked && (
          <Box sx={{
            position: 'absolute',
            top: 6,
            right: 6,
            width: 26,
            height: 26,
            borderRadius: '50%',
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <LockIcon sx={{ fontSize: 16, color: 'rgba(255,255,255,0.85)' }} />
          </Box>
        )}
      </Box>
      <Box sx={{ p: 1.5 }}>
        <Typography sx={{
          fontSize: '0.9rem',
          fontWeight: 'bold',
          color: 'white',
          mb: 0.25,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical'
        }}>
          {lesson.title}
        </Typography>
        {artist && (
          <Typography noWrap sx={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)' }}>
            {artist.name}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default LessonCard;
